import type { LucideIcon } from 'lucide-react';

/** A section heading's landmark: its icon on a tile of the accent tint. */
export function SectionIcon(props: { icon: LucideIcon }): React.JSX.Element {
  const Icon = props.icon;
  return (
    <span className="section-icon" aria-hidden="true">
      <Icon />
    </span>
  );
}
